import axios from 'axios';
import authHeader from "./auth-header";
import {config} from "../constants";

class SearchService {

    search(recordType,
           personNameSwitch,
           minMatchRate,
           includeLocalSanctions, includePeP, includeAdverseMedia,
           identification,
           personName, placeOfBirth, yearOfBirth,
           entityName, entityAddress,
           entityNameSwitch, entityIdentification, countryName) {

        let params

        if (recordType === "INDIVIDUAL") {
            if (personNameSwitch === true) {
                params = {
                    recordType,
                    minMatchRate,
                    includeLocalSanctions,
                    includePeP,
                    includeAdverseMedia,
                    personName,
                    placeOfBirth,
                    yearOfBirth
                }
            } else {
                params = {
                    recordType,
                    includeLocalSanctions,
                    identification
                }
            }
        } else if (recordType === "ENTITY") {
            if (entityNameSwitch === true) {
                params = {
                    recordType,
                    minMatchRate,
                    includeLocalSanctions, includePeP,
                    includeAdverseMedia,
                    entityName,
                    entityAddress
                }
            } else {
                params = {
                    recordType,
                    entityIdentification
                }
            }
        } else if (recordType === "COUNTRY") {
            params = {
                recordType,
                minMatchRate,
                includeAdverseMedia,
                countryName,
            }
        }

        return axios.get(config.API_URL + "search",
            {
                headers: authHeader(),
                params: params
            }
        )
    }

}

export default new SearchService();
